import { FALLTHROUGH_RULE_ID, flagLevelInstructionKinds } from './constants';
import type {
  FinalizationBehavior,
  StopReleasePhaseInstruction,
} from './internal/instructionTypes/releasePhaseInstruction';

export type StopScope = 'release' | 'fallthrough';

export function getStopScope(instruction: { fallthrough?: boolean }): StopScope {
  return instruction.fallthrough === true ? 'fallthrough' : 'release';
}

/**
 * Display copy for a stop's `finalizationBehavior`, used when the instruction directs the outcome
 * with a behavior instead of a served variation. The variation each behavior resolves to lives on
 * the release record, not the instruction, so the copy names the behavior alone.
 */
export const finalizationBehaviorDescriptions: Record<FinalizationBehavior, string> = {
  rollBackAllPhases: 'Roll back all phases',
  rollBackCurrentPhase: 'Roll back the current phase',
  rollForwardAllPhases: 'Roll forward all phases',
  rollForwardCurrentPhase: 'Roll forward the current phase',
};

/**
 * Builds a release-scoped `stopAutomatedRelease` instruction: the behavior directs the outcome,
 * and the fallthrough marker is set for a default-rule rollout so the backend can resolve the
 * required permission statically (verified server-side against the release, RO-3794).
 */
export function getStopAutomatedReleaseInstruction(params: {
  ruleId: string;
  releaseId: string;
  finalizationBehavior: FinalizationBehavior;
}): StopReleasePhaseInstruction {
  const { ruleId, releaseId, finalizationBehavior } = params;
  const instruction: StopReleasePhaseInstruction = {
    kind: flagLevelInstructionKinds.STOP_AUTOMATED_RELEASE,
    finalizationBehavior,
    releaseId,
  };
  if (ruleId === FALLTHROUGH_RULE_ID) {
    instruction.fallthrough = true;
  }
  return instruction;
}
